import { Link } from "react-router-dom";
import HomeImage from "../Images/Profile Picture.png";
// import compassImage from "../Images/compass illustration5.png";

function Home() {
  return (
    <div className="relative isolate pt-14">
      <section class="bg-white dark:bg-gray-900 mt-10">
        <div class="grid max-w-screen-xl px-4 pt-8 mx-auto lg:gap-8 xl:gap-0 lg:pt-16 lg:grid-cols-12">
          <div class="mr-auto place-self-center lg:col-span-6">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900 md:text-4xl xl:text-5xl">
              I'M ON A MISSION TO EMPOWER YOU TO MAKE{" "}
              <font color="#059669">SMART, INFORMED FINANCIAL DECISIONS</font>{" "}
              THAT LEAD TO A MORE MEANINGFUL AND FULFILLING LIFE.
            </h1>
            <div className="my-10 flex items-center justify-center gap-x-6">
              <Link
                to="/book"
                className="rounded-md bg-emerald-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                My Book
              </Link>
              <Link
                to="/speaking"
                className="rounded-md bg-emerald-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Speaking
              </Link>
            </div>
          </div>
          <div class="hidden lg:mt-0 lg:col-span-6 lg:flex">
            <img src={HomeImage} alt="mockup" />
          </div>
        </div>
      </section>
      <div className="bg-emerald-600 h-12 flex items-center justify-center"></div>
      <div className="bg-gray-200">
        <div className="flex justify-center p-10">
          <div className="bg-white shadow-lg rounded-xl overflow-hidden w-full max-w-6xl px-6 pb-6">
            <h5 class="block my-3 font-sans text-2xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-600">
              Speaker Reel
            </h5>
            <div className="relative h-0 pb-[56.25%]">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/irbOrjbx68M?si=Fog-aW_2QMdYliVU"
                title="YouTube video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap gap-8 justify-center pb-10">
          <div class="relative flex flex-col mt-6 text-gray-700 bg-white shadow-lg bg-clip-border rounded-xl w-96">
            <div class="relative h-56 mx-4 -mt-6 overflow-hidden text-white shadow-lg bg-clip-border rounded-xl bg-blue-gray-500 shadow-blue-gray-500/40">
              <img
                class="object-cover w-full h-full"
                src="https://www.stockvault.net/data/2009/05/08/108803/preview16.jpg"
                alt="money"
              />
            </div>
            <div class="p-6">
              <h5 class="block mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
                The Power of Early Investing
              </h5>
              <h6 class="block mb-2 font-sans text-md antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
                Why Your 20s Are Key to a Secure Retirement
              </h6>
              <p class="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
                Discover how starting to invest in your 20s can turn small
                monthly contributions into a secure retirement. Learn why even a
                few years can make a huge difference in your financial future
                and how you can maximize your wealth by starting early.
              </p>
            </div>
            <div class="p-6 pt-0">
              <a
                class="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
                href="/blogearlyinvesting"
              >
                Read More
              </a>
            </div>
          </div>

          <div class="relative flex flex-col mt-6 text-gray-700 bg-white shadow-lg bg-clip-border rounded-xl w-96">
            <div class="relative h-56 mx-4 -mt-6 overflow-hidden text-white shadow-lg bg-clip-border rounded-xl bg-blue-gray-500 shadow-blue-gray-500/40">
              <img
                class="object-cover w-full h-full"
                src="https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                alt="house"
              />
            </div>
            <div class="p-6">
              <h5 class="block mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
                The Real Impact of Your Credit Score
              </h5>
              <h6 class="block mb-2 font-sans text-md antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
                Why It Matters More Than You Think
              </h6>
              <p class="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
                A good credit score can save you thousands on home and car
                loans, turning costly interest payments into significant
                savings. Learn how a few credit score points can make all the
                difference.
              </p>
            </div>
            <div class="p-6 pt-0">
              <a
                class="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
                href="/blogcreditscore"
              >
                Read More
              </a>
            </div>
          </div>

          <div class="relative flex flex-col mt-6 text-gray-700 bg-white shadow-lg bg-clip-border rounded-xl w-96">
            <div class="relative h-56 mx-4 -mt-6 overflow-hidden text-white shadow-lg bg-clip-border rounded-xl bg-blue-gray-500 shadow-blue-gray-500/40">
              <img
                class="object-cover w-full h-full"
                src="https://images.pexels.com/photos/164634/pexels-photo-164634.jpeg"
                alt="stock ticker"
              />
            </div>
            <div class="p-6">
              <h5 class="block mb-2 font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">
                How Two Buyers Can Pay Drastically Different Prices at the Same
                Car Dealership
              </h5>
              <p class="block font-sans text-base antialiased font-light leading-relaxed text-inherit">
                In the car business, two buyers can pay drastically different
                prices for the same car on the same day. Learn how knowing the
                car's value and what you should pay can save you thousands.
              </p>
            </div>
            <div class="p-6 pt-0">
              <a
                class="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg bg-gray-900 text-white shadow-md shadow-gray-900/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none"
                href="/blog-car-dealerships"
              >
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
